import _get from 'lodash/get';

/**
 * Find inventory and owner data using inventoryId
 */
export default (function (state, inventoryId, isDealer) {
  if (state === void 0) {
    state = {};
  }
  const inventory = _get(state, `inventory.${inventoryId}`) || _get(state, `preorder.${inventoryId}`) || _get(state, 'cbhVehicleInterests.activeResults', []).find(listing => listing.id === inventoryId) || {};
  let owner = {};
  if (_get(inventory, 'owner.id')) {
    // if inventory.owner is already an object
    ({
      owner
    } = inventory);
  } else if (_get(state, `owners.${inventory.owner}`)) {
    // if inventory.owner is owner id
    owner = _get(state, `owners.${inventory.owner}`);
  } else if (isDealer) {
    owner = _get(state, `owners.${inventoryId}`, {});
  } else if (_get(inventory, 'ownerId')) {
    // sometimes the listing only has ownerId -- and owner data would be a separate object
    owner = {
      id: _get(inventory, 'ownerId')
    };
  }
  return {
    ...inventory,
    owner: {
      ...owner
    }
  };
});